<template>
  <div class="real-person-authentication-box">
    <div v-if="userProfile.kycStatus !== 2 && userProfile.kycStatus !== 3" class="real-person-authentication-before">
      <div class="real-person-authentication-tips">
        <img class="real-person-authentication-not-done-icon" src="/images/home/my_center_not_done_icon.png" alt="实名认证">
        <p class="real-person-authentication-not-done-text">请进行实人认证，认证通过后方可进行商品交易！根据相关规定，严禁未成年人购买虚拟商品！</p>
      </div>
      <div class="real-person-authentication-profile-box">
        <ul>
          <li>
            <label for="front-id-upload">
              <img class="real-person-authentication-profile-pic"
                :src="idFrontPreview || '/images/home/my_center_authentication_template_a.png'" alt="证件正面">
              <input type="file" id="front-id-upload" ref="idFrontInput" @change="uploadImage($event, 'front')"
                accept="image/jpeg,image/jpg,image/png" style="display: none;">
            </label>
            <p class="real-person-authentication-profile-text">上传身份证人像面</p>
          </li>
          <li>
            <label for="back-id-upload">
              <img class="real-person-authentication-profile-pic"
                :src="idBackPreview || '/images/home/my_center_authentication_template_b.png'" alt="证件反面">
              <input type="file" id="back-id-upload" ref="idBackInput" @change="uploadImage($event, 'back')"
                accept="image/jpeg,image/jpg,image/png" style="display: none;">
            </label>
            <p class="real-person-authentication-profile-text">上传身份证国徽面</p>
          </li>
        </ul>
      </div>
      <div class="real-person-authentication-profile-commit-btn" @click="submitAuthentication"
        :class="{ 'disabled-button': isSubmitting }" :style="{ 'pointer-events': isSubmitting ? 'none' : 'auto' }">
        <p class="real-person-authentication-profile-commit-btn-text">下一步</p>
      </div>
    </div>
    <div v-if="userProfile.kycStatus === 3" class="real-person-authentication-after">
      <div class="real-person-authentication-after-tips">
        <img class="real-person-authentication-has-done-icon" src="/images/home/my_center_has_done_icon.png" alt="实人认证">
        <p class="real-person-authentication-has-done-text">您已完成实人认证！</p>
      </div>
      <div class="real-person-authentication-after-profile-box">
        <ul>
          <li>
            <img class="real-person-authentication-after-profile-pic"
              src="https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/bdf04ecfe3394776bfd13ff0e856e7ab_mergeImage.png"
              alt="证件正面">
          </li>
          <li>
            <img class="real-person-authentication-after-profile-pic"
              src="https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/3a88bb6efdaf4cf19e3dc50c1afcac6d_mergeImage.png"
              alt="证件反面">
          </li>
        </ul>
      </div>
      <div class="real-person-authentication-after-commit-btn">
        <p class="real-person-authentication-after-commit-btn-text">重新认证</p>
      </div>
    </div>
    <div v-if="userProfile.kycStatus === 2" class="show-authentication-qrcode-box">
      <div class="show-authentication-qrcode-tip-box">
        <p class="show-authentication-qrcode-tip-text-01">人脸识别二维码</p>
        <p class="show-authentication-qrcode-tip-text-02">手机扫一扫</p>
      </div>
      <div class="show-authentication-qrcode-content">
        <img :src="qrcodeImage" alt="qrcodeImage" class="show-authentication-qrcode-content-img">
      </div>
      <div class="show-authentication-qrcode-btn-box" @click="clickRefreshRealPersonAuthenticationQRCodeHandler()">
        <p class="show-authentication-qrcode-btn-text">刷新二维码</p>
      </div>
      <div class="show-authentication-qrcode-warnning-box">
        <img class="show-authentication-qrcode-warnning-icon" src="/images/home/my_center_not_done_icon.png" alt="实名认证">
        <p class="show-authentication-qrcode-warnning-text">温馨提示：超过30分钟、失效、或者初始化错误，请刷新重试</p>
      </div>
    </div>
    <el-dialog title="确认信息" :visible.sync="dialogFormVisible" center>
      <el-form :model="confirmForm">
        <el-form-item label="真实姓名" :label-width="formLabelWidth" required>
          <el-input v-model="confirmForm.realName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" :label-width="formLabelWidth" required>
          <el-input v-model="confirmForm.identityCard" autocomplete="off"></el-input>
        </el-form-item>
        <p style="font-size: 12px;color: red;margin-left: 80px;">注意：请确认以上信息是否正确，若有误请手动更改</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commitRealPersonAuthenticationHandler()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { submitIdentityCard, preRealPersonAuthentication, refreshRealPersonAuthenticationQRCode, getKycStatusForRealPersonAuthentication } from '@/services/user/index.js';
import QRCode from 'qrcode';
import nprogress from 'nprogress';
import '../../../../public/css/nprogress.css';
nprogress.configure({ showSpinner: false });
export default {
  name: "MyAccountSettingRealPersonAuthentication",
  data() {
    return {
      idFrontPreview: '',
      idBackPreview: '',
      idFrontFile: null,
      idBackFile: null,
      isSubmitting: false, // 添加一个状态，防止重复提交
      dialogFormVisible: false,
      confirmForm: {
        realName: '',
        identityCard: ''
      },
      formLabelWidth: '80px',
      qrcodeImage: '',
      // 实人认证的轮询相关的状态
      pollTimer: null, // 存储定时器ID
      pollInterval: 3000, // 轮询间隔，例如3秒
      maxPollAttempts: 60, // 最大轮询次数，例如3秒 * 60次 = 180秒 (3分钟)
      currentPollAttempts: 0 // 当前轮询次数
    }
  },
  methods: {
    ...mapMutations('user', ['setUserProfileForKycStatus']),
    //上传提交证件
    uploadImage(event, type) {
      const file = event.target.files[0];
      this.uploadError = ''; // 清除之前的错误信息

      if (!file) {
        return;
      }

      // 1. 校验文件大小 (小于10M)
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        this.$message.warning('图片大小不能超过10MB');
        // 清空文件输入，防止用户重复选择
        if (type === 'front') {
          this.$refs.idFrontInput.value = '';
          this.idFrontPreview = '';
          this.idFrontFile = null;
        } else {
          this.$refs.idBackInput.value = '';
          this.idBackPreview = '';
          this.idBackFile = null;
        }
        return;
      }

      // 2. 校验文件格式
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        this.$message.warning('只允许上传 JPG, JPEG, PNG 格式的图片');
        // 清空文件输入
        if (type === 'front') {
          this.$refs.idFrontInput.value = '';
          this.idFrontPreview = '';
          this.idFrontFile = null;
        } else {
          this.$refs.idBackInput.value = '';
          this.idBackPreview = '';
          this.idBackFile = null;
        }
        return;
      }

      // 3. 存储文件并生成预览
      const reader = new FileReader();
      reader.onload = (e) => {
        if (type === 'front') {
          this.idFrontPreview = e.target.result;
          this.idFrontFile = file;
        } else {
          this.idBackPreview = e.target.result;
          this.idBackFile = file;
        }
      };
      reader.readAsDataURL(file);
    },
    //提交证件认证
    async submitAuthentication() {
      if (!this.idFrontFile || !this.idBackFile) {
        this.$message.warning('请上传身份证正反两面图片');
        return;
      }
      if (this.isSubmitting) {
        return; // 防止重复提交
      }
      //console.log('开始提交')
      nprogress.start();
      this.isSubmitting = true; // 设置提交状态

      const formData = new FormData();
      formData.append('idFront', this.idFrontFile); // 'idFront' 是后端接收文件时的参数名
      formData.append('idBack', this.idBackFile);   // 'idBack' 是后端接收文件时的参数名
      try {
        const { data } = await submitIdentityCard(formData);
        //console.log('submitAuthentication.data',data);
        if (data.code == 200) {
          this.dialogFormVisible = true;
          this.confirmForm.realName = data.data.realName;
          this.confirmForm.identityCard = data.data.identityCard;
        } else if (data.code == 500) {
          this.$message.warning('缺少必要参数')
        } else if(data.code == 25||data.code == 26||data.code == 29||data.code == 32){
          this.$message.warning(data.message);
        }
      } catch (err) { } finally {
        nprogress.done();
        this.isSubmitting = false; // 无论成功失败，都解除提交状态
      }
    },
    //提交请求 实人认证
    async commitRealPersonAuthenticationHandler() {
      this.dialogFormVisible = false;
      try {
        const { data } = await preRealPersonAuthentication(this.confirmForm);
        console.log(data);
        if (data.code == 200 && data.data) {
          this.setUserProfileForKycStatus(2); //提交的证件信息与实名认证一致，待实人认证
          // 脚本加载完成后，执行生成二维码的代码
          this.$nextTick(async () => { // 确保DOM更新完成后再操作DOM
            try {
              const url = await QRCode.toDataURL(data.data, {
                width: 160,
                margin: 1.5, // 边距
                color: {
                  dark: '#000000ff',  // Dark dots
                  light: '#ffffffff' // White background
                }
              })
              this.qrcodeImage = url;
              this.startPolling(); // 获取二维码成功后启动轮询
            } catch (err) {
              console.log('生成二维码失败:', err);
            }
          });
        } else if (data.code == 25 || data.code == 26 || data.code == 9) {
          this.$message.warning(data.message);
        } else {
          this.$message.warning('操作失败');
        }
      } catch (err) { }
    },

    //刷新实人认证二维码操作
    async clickRefreshRealPersonAuthenticationQRCodeHandler() {
      try {
        const { data } = await refreshRealPersonAuthenticationQRCode();
        if (data.code == 200 && data.data) {
          //console.log('刷新后的二维码链接是===');
          //console.log(data.data);
          this.$nextTick(async () => { // 确保DOM更新完成后再操作DOM
            try {
              const url = await QRCode.toDataURL(data.data, {
                width: 160,
                margin: 1.5, // 边距
                color: {
                  dark: '#000000ff',  // Dark dots
                  light: '#ffffffff' // White background
                }
              })
              this.qrcodeImage = url;
              this.startPolling(); // 获取二维码成功后启动轮询
            } catch (err) {
              console.log('生成二维码失败:', err);
            }
          });
        } else if (data.code == 9 || data.code == 29) {
          this.$message.warning(data.message);
        } else {
          this.$message.warning('认证失败，请重新认证！');
        }
      } catch (err) { }
    },
    //检查实人认证状态的API调用
    async checkRealPersonAuthenticationStatus() {
      try {
        // 假设你有一个API来获取用户最新的实人认证状态
        const { data } = await getKycStatusForRealPersonAuthentication(); // 替换为你的实际API调用
        // 假设后端返回的数据结构是 { code: 200, data: { kycStatus: 3 } }
        console.log('data', data)
        if (data.code === 200 && data.data && data.data === 3) {
          // 认证成功，停止轮询
          console.log('认证成功')
          this.stopPolling();
          this.$confirm('<div style="text-align: center;">人脸认证成功！</div>', "认证提示", {
            dangerouslyUseHTMLString: true, // 允许使用 HTML 字符串
            showConfirmButton: true,
            showCancelButton: false
          }).then(() => {
            this.setUserProfileForKycStatus(3); // 更新前端状态为认证成功
          }).catch(() => {
            // 用户点击了取消按钮，或者点击了蒙层
            this.setUserProfileForKycStatus(3); // 更新前端状态为认证成功
          });
          // 可能需要执行其他操作，例如刷新用户资料或跳转页面
        } else {
          // 如果kycStatus不是3，继续轮询
          console.log('认证中......')
          this.currentPollAttempts++;
          if (this.currentPollAttempts >= this.maxPollAttempts) {
            this.stopPolling();
            this.$message.warning('实人认证超时，请尝试重新认证。');
            // 可以在这里将kycStatus设置回2或其他状态，提示用户重新发起认证
            // this.setUserProfileForKycStatus(2);
          }
        }
      } catch (error) {
        console.error('检查实人认证状态失败:', error);
        // 错误处理，可能需要停止轮询或重试
        // this.stopPolling(); // 如果是严重错误，可以停止轮询
      }
    },
    // 启动轮询
    startPolling() {
      this.stopPolling(); // 确保在启动之前清除任何现有的定时器
      this.currentPollAttempts = 0; // 重置轮询次数
      this.pollTimer = setInterval(this.checkRealPersonAuthenticationStatus, this.pollInterval);
    },

    // 停止轮询
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    }

  },
  computed: {
    ...mapState({
      userProfile: state => state.user.userProfile
    })
  },
  mounted() {
    if (this.userProfile.kycStatus === 2) {
      this.clickRefreshRealPersonAuthenticationQRCodeHandler();
    }
  },
  // 在组件的生命周期钩子中停止轮询
  beforeDestroy() {
    this.stopPolling();
  },
}
</script>

<style lang="less" scoped>
.real-person-authentication-box {
  background: #FFFFFF;
  width: 1200px;
  margin-top: 20px;

  .real-person-authentication-before {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .real-person-authentication-tips {
      width: 546px;
      height: 36px;
      background: #FFF0F1;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: default;

      .real-person-authentication-not-done-icon {
        width: 12px;
        height: 12px;
      }

      .real-person-authentication-not-done-text {
        margin-left: 10px;
        height: 16px;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #F02233;
        line-height: 16px;
        text-align: left;
        font-style: normal;
      }
    }

    .real-person-authentication-profile-box {
      margin-top: 20px;
      width: 1200px;

      ul {
        width: 1200px;
        list-style-type: none;
        padding: 0;
        display: flex;
        justify-content: center;

        li {
          list-style: none;
          width: 335px;
          height: 211px;
          background: #FFFFFF;
          border-radius: 10px;
          border: 1px solid #EBEBEB;
          margin-left: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .real-person-authentication-profile-pic {
            width: 237px;
            height: 145px;
          }

          .real-person-authentication-profile-text {
            margin-top: 9px;
            height: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #1A1A1A;
            line-height: 20px;
            text-align: right;
            font-style: normal;
          }
        }
      }
    }

    .disabled-button {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .real-person-authentication-profile-commit-btn {
      margin-top: 50px;
      width: 200px;
      height: 46px;
      background: #F02233;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      user-select: none;
      transition: opacity 0.3s ease;

      .real-person-authentication-profile-commit-btn-text {
        height: 14px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 14px;
        text-align: right;
        font-style: normal;
      }
    }
  }

  .real-person-authentication-after {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;

    .real-person-authentication-after-tips {
      display: flex;
      width: 150px;
      height: 36px;
      background: #ECFFF5;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: default;

      .real-person-authentication-has-done-icon {
        width: 12px;
        height: 12px;
      }

      .real-person-authentication-has-done-text {
        margin-left: 10px;
        height: 16px;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #2CA767;
        line-height: 16px;
        text-align: left;
        font-style: normal;
      }
    }

    .real-person-authentication-after-profile-box {
      margin-top: 20px;
      width: 1200px;

      ul {
        width: 1200px;
        list-style-type: none;
        padding: 0px;
        display: flex;
        justify-content: center;
        align-items: center;

        li {
          margin-left: 40px;
          list-style: none;
          width: 335px;
          height: 211px;
          background: #FFFFFF;
          border-radius: 10px;
          border: 1px solid #EBEBEB;

          .real-person-authentication-after-profile-pic {
            width: 335px;
            height: 211px;
          }
        }
      }
    }

    .real-person-authentication-after-commit-btn {
      margin-top: 50px;
      width: 200px;
      height: 46px;
      background: #FFF7F7;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: default;

      .real-person-authentication-after-commit-btn-text {
        height: 14px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 14px;
        color: #FF707B;
        line-height: 14px;
        text-align: right;
        font-style: normal;
      }
    }


  }

  .show-authentication-qrcode-box {
    margin-top: 20px;
    width: 1200px;
    height: 363px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .show-authentication-qrcode-tip-box {
      display: flex;
      flex-direction: column;
      align-items: center;

      .show-authentication-qrcode-tip-text-01 {
        height: 16px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #F02233;
        line-height: 16px;
        text-align: left;
        font-style: normal;
      }

      .show-authentication-qrcode-tip-text-02 {
        margin-top: 14px;
        height: 16px;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #F02233;
        line-height: 16px;
        text-align: left;
        font-style: normal;
      }
    }

    .show-authentication-qrcode-content {
      width: 180px;
      height: 180px;
      margin-top: 14px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #FF707B;

      .show-authentication-qrcode-content-img {
        width: 160px;
        height: 160px;
        background: #FFFFFF;
        border-radius: 4px;
      }
    }

    .show-authentication-qrcode-btn-box {
      margin-top: 14px;
      width: 100px;
      height: 32px;
      background: #F02233;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: default;

      .show-authentication-qrcode-btn-text {
        height: 14px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 14px;
        text-align: right;
        font-style: normal;
      }
    }

    .show-authentication-qrcode-warnning-box {
      margin-top: 14px;
      // width: 546px;
      height: 36px;
      background: #FFF0F1;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: default;
      padding: 0px 14px;

      .show-authentication-qrcode-warnning-icon {
        width: 12px;
        height: 12px;
      }

      .show-authentication-qrcode-warnning-text {
        margin-left: 10px;
        height: 16px;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #F02233;
        line-height: 16px;
        text-align: left;
        font-style: normal;
      }
    }
  }

}
</style>